import React, { useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router";
import useApp from '../../store/app/appContext';
import PageWrapper from './PageWrapper';
import ACTIONS from '../../store/actions';
import { API_BASE_URL } from "../../config";
import { useHistory } from 'react-router-dom';

function VerifyAccount() {
  const { dispatch } = useApp();

  const { token } = useParams();
  const history = useHistory();

  useEffect(() => {
    if(token) {
      axios.get(`${API_BASE_URL}/user/verify-account/${token}`).then(res => {
        const response = res.data;
        if (response.success) {
          axios.defaults.headers.common['x-access-token'] = token;
          localStorage.setItem('jwtToken', token);
          axios.get(`${API_BASE_URL}/user/me`).then(res => {
            const response = res.data;
            dispatch({
              type: ACTIONS.AUTHENTICATE_COMPLETE,
              payload: response.data
            })
            history.push('/dashboard?verified=true');
          })
        }
      })
      
    }
  }, [dispatch, token])
 
  return (
    <PageWrapper/>
  );
}

export default VerifyAccount;
